export default {
  ethereum: 'ETH',
  solana: 'SOL',
  polygon: 'POLYGON',
  bsc: 'BSC',
  cardano: 'ADA',
}
